import $ from 'jquery';
import {renderIfNeeded} from 'shared/tools';
import RenewSessionContainer from 'main/containers/login/components/RenewSessionContainer';
import {getExpiryDate, setHandleSessionExpirationCallback} from 'shared/core/sessionExpirationTimeout';
/*global document*/

const SVG = '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" class="blur-svg"> <defs> <filter id="blur-filter"> <feGaussianBlur stdDeviation="3"></feGaussianBlur> </filter> </defs> </svg>';

function handleSessionExpiration() {
  let sessionExpiryContainer = $('#cr-session-expiry');
  if (!sessionExpiryContainer.length) {
    sessionExpiryContainer = $("<div id='cr-session-expiry'>").append(SVG);
    $(document.body).append(sessionExpiryContainer);
  }

  renderIfNeeded(RenewSessionContainer, 'cr-session-expiry', {expiryDate: getExpiryDate()});
}

export function setupSessionExpirationUI(){
  setHandleSessionExpirationCallback(handleSessionExpiration);
}
